export default class PointsIntegration{
    constructor() {
        const productWrapper = jQuery(document).find(ywdpd_qty_args.column_product_info_class);
        this.pointMessageDiv = productWrapper.find('.yith-par-message-product');
        this.defaultMessage = this.pointMessageDiv.length ? this.pointMessageDiv : '';

        jQuery(document).on('ywdpd_price_html_updated', this.updatePointsMessage.bind(this) );

    }

    updatePointsMessage(event, rawPrice, price,tdQuantity ){
        if( typeof  tdQuantity !== 'undefined' && tdQuantity.length > 0) {
            const type = tdQuantity.parents('table').data('product_type');
            let currentMessageDiv = '';
            if ('variation' === type) {
                currentMessageDiv = jQuery(document).find(ywdpd_qty_args.column_product_info_class).find('.yith-par-message-variation');
            } else {
                currentMessageDiv = this.pointMessageDiv;
            }

            if( currentMessageDiv.length ) {
                if (typeof price === 'undefined') {
                    currentMessageDiv.html( this.defaultMessage);
                } else {
                    let data = {
                        action: ywdpd_qty_args.integrations.actions.update_product_points_message,
                        security: ywdpd_qty_args.integrations.nonces.update_product_points_message,
                        product_id: tdQuantity.parents('table').data('product_id'),
                        dynamic_price: price,
						qty: jQuery('form.cart .qty').val()
                    };
                    jQuery.ajax({
                        type: 'POST',
                        url: ywdpd_qty_args.ajax_url,
                        data,
                        dataType: 'json',
                        beforeSend() {
                        },
                        success(response) {
                            if (response?.data) {
                                if (response.data.show) {
                                    currentMessageDiv.show();
                                } else {
                                    currentMessageDiv.hide();
                                }
                                currentMessageDiv.html(response.data.message);

                            }
                        },
                        complete() {
                        },
                    });
                }
            }
        }
    }
}